import i18n from "lib/i18n";
import $ from "jquery";
import { defer, map, template } from "lodash";
import { View } from "backbone";
import Comments from "models/comments";
import CommentsRecommends from "collections/comments_recommends";
import ContentSubscription from "models/content_subscription";
import CommentsSignedInPermissions from "permissions/comments_signed_in_permissions";
import CommentsEditorPermissions from "permissions/comments_editor_permissions";
import CommentsModeratorPermissions from "permissions/comments_moderator_permissions";
import CommentsUnauthedPermissions from "permissions/comments_unauthed_permissions";
import CommentsListView from "views/comments_list_view";
import CommentsActionsView from "views/comments_actions_view";
import Minpubsub from "minpubsub";
import moment from "moment";
import refreshCSRFToken from "lib/refreshCSRFToken";
import { currentUser } from "lib/currentUser";
import { isSessionActive } from "lib/currentUser/session";
import { wrapInUserModel } from "models/user";
import { track } from "lib/analytics";

/* eslint-disable
    consistent-return,
    constructor-super,
    func-names,
    max-len,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentsSectionView;

const COMMENTS_CONTAINER_SELECTOR = "#comments-container";

export default CommentsSectionView = (function () {
  CommentsSectionView = class CommentsSectionView extends View {
    static initClass() {
      this.prototype.id = "comments";
      this.prototype.className = "comments-section-view wrapper clearfix";
      this.prototype.tagName = "section";

      this.prototype.events = {
        "click a.comment-sort": "sortComments",

        "click .comment-moderator-remove": "showModeratorPane",
        "click .moderation-pane-close": "hideModerationPane",

        "submit .moderation-remove": "handleModerationRemoveSubmit",
      };

      this.prototype.sortButtonsTemplate = template(`
<div class="comment-sorting">
  <div class="tabbed-button-group minimal">
    <a class=" button comment-sort on" href="#oldest">
      <%= i18n.t('comment.button.oldest') %>
    </a>

    <a class=" button comment-sort" href="#newest">
      <%= i18n.t('comment.button.newest') %>
    </a>
  </div>
</div>
      `, { imports: { i18n },
      });

      this.prototype.showAllCommentsButtonTemplate = template(`\
<div class="comments-show-all">
  <a href="#" class="primary button large">
    <%= i18n.t('comment.button.show_all_comments') %>
  </a>
</div>\
`, { imports: { i18n } });

      this.prototype.template = template(`\
<div class="comments-bar grid-sixteen">
  <div class="comments-side grid-four grid-last"></div>
  <div class="comments-count-sort grid-four">
    <span class="comment-count"></span>
  </div>
  <div class="comments-main grid-eight">
    <p class="information prominent closed"><%= i18n.t('comment.label.comments_closed') %></p>
  </div>
</div>\
`, { imports: { i18n } });
    }

    initialize(options) {
      super.initialize(options);

      this.fetchComments = this.fetchComments.bind(this);
      this._transitionToReady = this._transitionToReady.bind(this);
      this._newComment = this._newComment.bind(this);
      this._commentsOpened = this._commentsOpened.bind(this);
      this._commentsClosed = this._commentsClosed.bind(this);
      this.renderComments = this.renderComments.bind(this);
      this._renderSortButtons = this._renderSortButtons.bind(this);
      this._renderShowMoreButton = this._renderShowMoreButton.bind(this);
      this.scrollToComments = this.scrollToComments.bind(this);
      this.setup = this.setup.bind(this);

      this.scrollToComments();
      this.render(options);
    }

    /**
     * @param {Object} options
     */
    render(options) {
      // Feature detection for IE. IntersectionObserver is not available for IEs
      if (typeof IntersectionObserver === "undefined") {
        this.renderComments(options);
        return;
      }

      const observedCommentContainerEl = document.querySelector(COMMENTS_CONTAINER_SELECTOR);

      // We don't want to attach an IntersectionObserver comments container isn't present, such as on approved content
      // pages viewed by authors.
      if (observedCommentContainerEl === null) { return; }

      const commentContainerObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.renderComments(options);
            observer.disconnect();
          }
        });
      });
      commentContainerObserver.observe(observedCommentContainerEl);
    }

    /**
     * @param {Object} options
     */
    async renderComments(options) {
      await refreshCSRFToken();
      await this.setup(options);

      this.el.innerHTML = this.template();
      this.commentsListView.$el.appendTo(this.$el.find(".comments-main"));
      this.fetchComments();
      this.$el.addClass("loading");
    }

    sortComments(event) {
      event.preventDefault();
      const link = $(event.currentTarget);
      const order = link.attr("href");

      this.$el.find(".comment-sort").removeClass("on");
      link.addClass("on");

      return this.commentsListView.sortComments(order);
    }

    _transitionToReady() {
      this.$el.removeClass("loading");
      this._commentsClosed(this.commentsClosedAt);

      if (this.comments.get("comment_count")) {
        this._renderSortButtons();
        if (!this._displayAllComments()) { this._renderShowMoreButton(); }
      } else {
        this.commentsListView.renderNoComments();
      }

      this.commentsActionsView.$el.appendTo(this.$el.find(".comments-side"));

      // bit of a hack to handle direct links to comments
      if (this.referenceToComment && ($(this.referenceToComment).length > 0)) {
        return defer(() => $("html, body").animate(
            { scrollTop: $(this.referenceToComment).addClass("highlight").offset().top }
          , 0));
      }
    }

    _newComment(parentId) {
      return this.commentsListView.createNewComment(this.contentId, parentId);
    }

    _userRecommendedCommentIds() {
      if (this.commentsRecommends) {
        return map(this.commentsRecommends.models, recommend => recommend.get("comment_id"));
      }
    }

    _commentsOpened() {
      return this.$el.removeClass("closed");
    }

    _commentsClosed(closedTimestamp) {
      const now = moment();
      const closed = moment(closedTimestamp);

      if (closed.isBefore(now)) {
        this.$el.addClass("closed");
      }
    }

    _displayAllComments() {
      return this.displayAllComments || this.comments.get("has_current_user_comment") || this.referenceToComment || (this.comments.get("comment_count") < 3);
    }

    fetchComments() {
      this.commentsRecommends = isSessionActive() ? new CommentsRecommends({ content_id: this.contentId }) : undefined;
      isSessionActive() ?
        this.commentsRecommends.fetch().then(() => this.comments.fetch()) :
        this.comments.fetch();
    }

    scrollToComments() {
      const hash = $(location).attr("hash");
      if (/comment_[0-9]+/.test(hash)) {
        this.referenceToComment = hash;
      }

      // bit of a hack to handle direct links to comments
      if (this.referenceToComment) {
        defer(() => {
          $("html, body").animate({ scrollTop: $("#comments").offset().top }, 500);
        });
      }
    }

    _renderSortButtons() {
      // If the sort buttons haven't already been rendered.
      if (this.$el.find(".comment-sorting").length === 0) {
        // render the sort buttons.
        this.$el.find(".comments-main").prepend(this.sortButtonsTemplate());
      }
    }

    _renderShowMoreButton() {
      const button = $(this.showAllCommentsButtonTemplate());
      this.$el.find(".comments-main").append(button);

      return button.on("click", (event) => {
        event.preventDefault();
        button.attr("disabled", "disabled");

        track("Comments - Show all", "click");

        this.displayAllComments = true;
        return this.commentsListView.renderAllComments(() => button.remove());
      });
    }

    /**
     * Setup the comment section, configuring direct links to comments (URL fragments),
     * The Current user, Feature flags (user permissions) for comment management,
     * comment rendering based on Comment Backbone model sync.
     *
     * @param {Object} options
     */
    async setup(options) {
      const user = await currentUser().then(wrapInUserModel);

      this.permissions = (() => {
        if (user.isEditor()) {
          return new CommentsEditorPermissions();
        }

        if (user.isModerator()) {
          return new CommentsModeratorPermissions();
        }

        if (user.exists()) {
          return new CommentsSignedInPermissions();
        }

        return new CommentsUnauthedPermissions();
      })();

      this.contentId = options.content_id;
      this.commentsClosedAt = options.commentsClosedAt;
      this.comments = new Comments({ content_id: this.contentId });
      this.contentSubscription = new ContentSubscription({ content_id: this.contentId });

      this.commentsActionsView = new CommentsActionsView({
        contentId: this.contentId,
        permissions: this.permissions,
        contentSubscription: this.contentSubscription,
        user,
      });
      this.commentsListView = new CommentsListView({
        model: this.comments,
        permissions: this.permissions,
        contentSubscription: this.contentSubscription,
      });

      Minpubsub.subscribe("comment:new", this._newComment);
      Minpubsub.subscribe("comment:created", this.commentsListView.addComment);
      Minpubsub.subscribe("comments:fragment:ready", this._transitionToReady);
      Minpubsub.subscribe("comments:closed", this._commentsClosed);
      Minpubsub.subscribe("comments:opened", this._commentsOpened);

      // TODO: determine what this value should be based on various things (commented/cookie?)
      this.displayAllComments = false;
      this.comments.on("sync", () => this.commentsListView.renderComments(this.comments, this._userRecommendedCommentIds(), this._displayAllComments()));
    }
  };

  CommentsSectionView.initClass();
  return CommentsSectionView;
}());
